import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';

import { ItemLinhaRoutingModule } from './item-linha-routing.module';
import { ItemLinhaComponent } from './item-linha.component';
import { ItemLinhaFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        ItemLinhaRoutingModule
    ],
    declarations: [
        ItemLinhaComponent,
        ItemLinhaFormComponent
    ]
})
export class ItemLinhaModule { }
